import { IAppState } from 'spw-redux/reducer';
import { omit } from 'lodash';
import { PlainWorksheet } from '../models/Worksheet';

const TOO_MUCH_DATA = '<DATA OMITTED>';

export const sentryEnhancerOptions = {
  actionTransformer: (action: any) => {
    if (action.type === 'UPLOAD_FLOORPLAN_SUCCEEDED') {
      return null;
    }
    return action;
  },
  stateTransformer: (state: IAppState) => {
    const transformedState = {
      ...omit(state, [
        'authReducer',
        'feedbackReducer',
        'buildingDetailReducer',
        'messagesReducer',
        'workplaceBehavior',
      ]),
      userReducer: {
        user: {
          userId: state.userReducer.user.id,
          organizationId: state.userReducer.user.organizationId,
        },
      },
      organizationsReducer: {
        currentOrganization: {
          id: state.organizationsReducer.currentOrganization?.id,
        },
      },
      projectsReducer: {
        currentProjectType: state.projectsReducer.currentProjectType,
        currentProject: state.projectsReducer.currentProject,
        currentBuilding: `${state.projectsReducer.currentBuilding?.id || ''} ${
          state.projectsReducer.currentBuilding?.city || ''
        } ${state.projectsReducer.currentBuilding?.streetAddress || ''}`.trim(),
        currentFloor: state.projectsReducer.currentFloor,
        departments: state.projectsReducer.departments,
      },
      floorplanReducer: {
        currentFloorplan: {
          ...state.floorplanReducer.currentFloorplan,
          image: '',
        },
        shapes: state.floorplanReducer.shapes,
        spacesMap: state.floorplanReducer.spacesMap,
        calibration: state.floorplanReducer.calibration,
        clusters: state.floorplanReducer.clusters,
      },
      programSummaryReducer: {
        keyData: state.programSummaryReducer.keyData,
        workplaceBehavior: state.programSummaryReducer.workplaceBehavior,
        workspaceBreakdown: state.programSummaryReducer.workspaceBreakdown,
        usfTotal: state.programSummaryReducer.usfTotal,
      },
      ouReducer: {
        rounds: state.ouReducer.rounds,
        currentRound: state.ouReducer.currentRound,
        usages: state.ouReducer.usages,
      },
      calculatorReducer: {
        currentScenario: state.calculatorReducer.currentScenario,
        currentCalculatorType: state.calculatorReducer.currentCalculatorType,
        scenarios: state.calculatorReducer.scenarios,
        worksheet: state.calculatorReducer.worksheet
          ? {
              ...state.calculatorReducer.worksheet,
              rows: TOO_MUCH_DATA,
              rowsByCategory: TOO_MUCH_DATA,
              rowsBySubcategory: TOO_MUCH_DATA,
              breakDownRows: TOO_MUCH_DATA,
              scenario: TOO_MUCH_DATA,
            }
          : null,
        worksheets: state.calculatorReducer.worksheets?.map(
          (ws: PlainWorksheet) => ({
            ...ws,
            rows: TOO_MUCH_DATA,
            rowsByCategory: TOO_MUCH_DATA,
            rowsBySubcategory: TOO_MUCH_DATA,
            breakDownRows: TOO_MUCH_DATA,
            scenario: TOO_MUCH_DATA,
          })
        ),
      },
    };

    return transformedState;
  },
};
